const MenuLinks = [
  {
    country: 'Costa Rica',
    items: [
      {
        id: '1',
        titulo: 'Facilidades de Crédito',
        slug: 'es-cr/tarjetas/credito/facilidades-de-credito',
        orden: 1,
      },
   
      { id: '3', titulo: 'Seguros y Asistencias', slug: 'es-cr/seguros', orden: 3 },
      {
        id: '4',
        titulo: 'Gestiones',
        slug: 'es-cr/tarjetas/credito/gestiones-complementarias',
        orden: 4,
      },
      {
        id: '6',
        titulo: 'Promociones',
        slug: 'es-cr/promotions-page',
        orden: 6,
      },
      {
        id: '2',
        titulo: 'Salas VIP',
        slug: '/es-cr/salas-vip',
        orden: 2,
      },
      {
        id: '5',
        titulo: 'Valet Parking',
        slug: 'es-cr/valet-parking-de-bac-credomatic',
        orden: 5,
      },
    ],
  },
  {
    country: 'Nicaragua',
    items: [
      {
        id: '1',
        titulo: 'Nuestras tarjetas',
        slug: 'es-ni/tarjetas/credito/personas',
        orden: 1,
      },
      {
        id: '2',
        titulo: 'Programas de lealtad',
        slug: 'es-ni/tarjetas/credito/programas-de-lealtad',
        orden: 2,
      },
      {
        id: '3',
        titulo: 'Facilidades de crédito',
        slug: 'es-ni/tarjetas/credito/facilidades-de-credito',
        orden: 3,
      },
      {
        id: '4',
        titulo: 'Gestiones',
        slug: 'es-ni/tarjetas/credito/gestiones-complementarias',
        orden: 4,
      },
      {
        id: '5',
        titulo: 'Servicios',
        slug: 'es-ni/tarjetas/credito/servicios',
        orden: 5,
      },
      {
        id: '6',
        titulo: 'Promociones',
        slug: 'https://www.mipromo.com/',
        orden: 6,
      },
    ],
  },
  {
    country: 'Guatemala',
    items: [
      {
        id: '1',
        titulo: 'Personas',
        slug: 'es-gt/tarjetas/credito/personas',
        orden: 1,
      },
      {
        id: '2',
        titulo: 'Empresas',
        slug: 'es-gt/tarjetas/credito/empresas',
        orden: 2,
      },
      {
        id: '3',
        titulo: 'Programas de lealtad',
        slug: 'es-gt/tarjetas/credito/programas-de-lealtad',
        orden: 3,
      },
      {
        id: '4',
        titulo: 'Gestiones',
        slug: 'es-gt/tarjetas/credito/gestiones-complementarias',
        orden: 4,
      },
      {
        id: '5',
        titulo: 'Servicios',
        slug: 'es-gt/tarjetas/credito/servicios',
        orden: 5,
      },
      {
        id: '6',
        titulo: 'Promociones',
        slug: 'es-gt/promotions-page',
        orden: 6,
      },
      {
        id: '7',
        titulo: 'Transparencia',
        slug: 'es-gt/tarjetas/credito/transparencia',
        orden: 7,
      },
    ],
  },
  {
    country: 'Honduras',
    items: [
      {
        id: '1',
        titulo: 'Personas',
        slug: 'es-hn/tarjetas/credito/personas',
        orden: 1,
      },
      {
        id: '2',
        titulo: 'Empresas',
        slug: 'es-hn/tarjetas/credito/empresas',
        orden: 2,
      },
      {
        id: '3',
        titulo: 'Programas de Lealtad',
        slug: 'es-hn/tarjetas/credito/programas-de-lealtad',
        orden: 3,
      },
      {
        id: '4',
        titulo: 'Facilidades de Crédito',
        slug: 'es-hn/tarjetas/credito/facilidades-de-credito',
        orden: 4,
      },
      {
        id: '5',
        titulo: 'Gestiones',
        slug: 'es-hn/tarjetas/servicios',
        orden: 5,
      },
      {
        id: '6',
        titulo: 'Servicios',
        slug: 'es-hn/tarjetas/credito/servicios',
        orden: 6,
      },
    ],
  },
  {
    country: 'Panamá',
    items: [
      { id: '1', titulo: 'Préstamos', slug: 'es-pa/prestamos', orden: 1 },
      { id: '2', titulo: 'Cuentas', slug: 'es-pa/cuentas', orden: 2 },
      { id: '3', titulo: 'Seguros', slug: 'es-pa/seguros', orden: 3 },
      {
        id: '4',
        titulo: 'Canales de Servicio',
        slug: 'es-pa/tutoriales',
        orden: 4,
      },
    ],
  },
  {
    country: 'El Salvador',
    items: [
      {
        id: '1',
        titulo: 'Personas',
        slug: 'es-sv/tarjetas/credito/personas',
        orden: 1,
      },
      {
        id: '2',
        titulo: 'Empresas',
        slug: 'es-sv/tarjetas/credito/empresas',
        orden: 2,
      },
      {
        id: '3',
        titulo: 'Programas de Lealtad',
        slug: 'es-sv/tarjetas/credito/programas-de-lealtad',
        orden: 3,
      },
      {
        id: '4',
        titulo: 'Beneficios',
        slug: 'es-sv/tarjetas/credito/beneficios',
        orden: 4,
      },
      {
        id: '5',
        titulo: 'Gestiones',
        slug: 'es-sv/tarjetas/credito/gestiones-complementarias',
        orden: 5,
      },
      {
        id: '6',
        titulo: 'Servicios',
        slug: 'es-sv/tarjetas/credito/servicios',
        orden: 6,
      },
      {
        id: '7',
        titulo: 'Promociones',
        slug: 'es-sv/promotions-page',
        orden: 7,
      },
    ],
  },
]

export default MenuLinks
